export const convertToPositiveNumberIfPossible = (numberString: string): number => {
  const convertedNum = Number.parseInt(numberString, 10);
  if (Number.isNaN(convertedNum)) return -1;
  return convertedNum;
};
